import { ColumnsType } from 'antd/lib/table'
import renderDatetime from '../../../../helpers/tables/render-datetime'
import { DesignerTaskRow } from '../helpers/calc-designer-monthly-stats'

export const columns: ColumnsType<DesignerTaskRow> = [
    {
        dataIndex: 'id',
        title: '№',
        width: 80,
    },
    {
        dataIndex: 'type',
        title: 'Тип',
        width: 160,
    },
    {
        dataIndex: 'details',
        title: 'Детали',
    },
    {
        dataIndex: 'contribution',
        title: 'Кол-во',
        width: 70,
        align: 'left',
    },
    {
        dataIndex: 'clientName',
        title: 'Клиент',
        width: 160,
    },
    {
        dataIndex: 'shipmentId',
        title: '№ отгрузки',
        width: 110,
    },
    {
        dataIndex: 'completedAt',
        title: 'Дата',
        width: 160,
        render: (_, record) => renderDatetime(record.completedAt),
    },
]
